import React from 'react';
import PropTypes from 'prop-types';
import DomainMediaIcon from './components/domain-media-icon';
import * as styles from '../style/media-banner';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MediaBanner = _ref => {
  var links = _ref.links,
    isFullWidth = _ref.isFullWidth;
  return ___EmotionJSX("section", {
    css: styles.banner
  }, ___EmotionJSX("div", {
    css: styles.bannerInner(isFullWidth)
  }, ___EmotionJSX(DomainMediaIcon, null), links.map(_ref2 => {
    var label = _ref2.label,
      url = _ref2.url;
    return ___EmotionJSX("a", {
      css: styles.bannerLink,
      href: url,
      key: url
    }, ' ', label, ' ');
  })));
};
MediaBanner.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })),
  isFullWidth: PropTypes.bool
};
MediaBanner.defaultProps = {
  links: [],
  isFullWidth: false
};
export default MediaBanner;